import ShopifyVariantHeader from './ShopifyVariantHeader'
import ShopifyVariantBundleView from './ShopifyVariantBundleView'
import ShopifyVariantWCDView from './ShopifyVariantWCDView'
import ShopifyVariantPriceView from './ShopifyVariantPriceView'

import { getAugmentedVariant } from '@/lib/variant'

import classNames from 'classnames'
import { useEffect } from 'react'

// Hooks
import useLocations from '@/hooks/useLocations'

export default function ShopifyVariant({
    variant,
    product,
    locationId,
    fetchProduct,
    sortedComponents,
    view,
}) {
    const locations = useLocations()
    locationId = parseInt(locationId)
    const location = locations.find((l) => l.id === locationId)
    const shopifyLocationId = location?.shopify_location_id

    const v = getAugmentedVariant(variant, locationId)

    const physicalsAtLocation = v.components.map((c) => c.physicalAtLocation).filter((v) => v !== null)
    const physicalAtLocation = physicalsAtLocation.length > 0 ? Math.min(...physicalsAtLocation) : null

    const b2cValues = v.components
        .filter((c) => c.availability_b2c === 'follow')
        .map((c) => c.availableAtLocation)
        .filter((v) => v !== null)
    const availableAtLocationB2C = b2cValues.length > 0 ? Math.min(...b2cValues) : null

    const b2bValues = v.components
        .filter((c) => c.availability_b2b === 'follow')
        .map((c) => c.availableAtLocation)
        .filter((v) => v !== null)
    const availableAtLocationB2B = b2bValues.length > 0 ? Math.min(...b2bValues) : null

    const shopifyAvailableAtLocation = v.available_quantities[14030110791] ?? 0

    // Get the param variant_id from the url
    const variantId = new URLSearchParams(window.location.search).get(
        'variant_id'
    )
    const isSearchVariant = variantId == v.id

    // Scroll to this element if it is the search variant (with margin top)
    useEffect(() => {
        if (isSearchVariant) {
            const element = document.getElementById(`variant-${v.id}`)
            element.scrollIntoView({ behavior: 'instant', block: 'center' })
        }
    }, [isSearchVariant])

    return (
        <div key={v.id} id={`variant-${v.id}`}>
            <div className="flex flex-col gap-5 items-start">
                <ShopifyVariantHeader
                    variant={v}
                    product={product}
                    isSearchVariant={isSearchVariant}
                />

                {view === 'bundles' && (
                    <ShopifyVariantBundleView
                        variant={v}
                        product={product}
                        fetchProduct={fetchProduct}
                        sortedComponents={sortedComponents}
                        physicalAtLocation={physicalAtLocation}
                        availableAtLocationB2C={availableAtLocationB2C}
                        availableAtLocationB2B={availableAtLocationB2B}
                    />
                )}

                {view === 'wcd' && (
                    <ShopifyVariantWCDView
                        variant={variant}
                        product={product}
                        fetchProduct={fetchProduct}
                    />
                )}

                {view === 'price' && (
                    <ShopifyVariantPriceView
                        variant={variant}
                        product={product}
                        fetchProduct={fetchProduct}
                    />
                )}
            </div>
        </div>
    )
}
